import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';

export type BulkArchiveSkipReason = 'NOT_FOUND' | 'COMPLETED' | 'ARCHIVED';

type BulkArchiveServiceRequestsParams = {
  serviceRequestIds: string[];
  archiveReason: string;
};

export type BulkArchiveServiceRequestsResponse = {
  archivedIds: string[];
  skipped: { id: string; reason: BulkArchiveSkipReason }[];
};

type BulkArchiveServiceRequestsResult = {
  success: boolean;
  data?: BulkArchiveServiceRequestsResponse;
  error?: string;
  statusCode?: number;
};

export async function bulkArchiveServiceRequests({
  serviceRequestIds,
  archiveReason,
}: BulkArchiveServiceRequestsParams): Promise<BulkArchiveServiceRequestsResult> {
  try {
    const response = await fetcher(`${API_BASE_PATH}/bulk/archive`, {
      method: 'POST',
      body: { serviceRequestIds, archiveReason },
    });

    if (!response.ok) {
      const responseData = await response.json().catch(() => null);
      return {
        success: false,
        error: getErrorMessage(responseData?.message),
        statusCode: response.status,
      };
    }

    const responseData: BulkArchiveServiceRequestsResponse =
      await response.json();
    return { success: true, data: responseData };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to cancel service requests',
      statusCode: 500,
    };
  }
}

function getErrorMessage(message: unknown): string {
  if (Array.isArray(message)) return message.join(', ');
  if (typeof message === 'string' && message) return message;
  return 'Failed to cancel service requests';
}
